export default "__VITE_ASSET__D$aZS8hO__"